import { render, staticRenderFns } from "./tabmenu-element.vue?vue&type=template&id=2ae29422&scoped=true&"
import script from "./tabmenu-element.vue?vue&type=script&lang=js&"
export * from "./tabmenu-element.vue?vue&type=script&lang=js&"
import style0 from "./tabmenu-element.vue?vue&type=style&index=0&id=2ae29422&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae29422",
  null
  
)

export default component.exports